var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"main",attrs:{"direction":"vertical"}},[_c('dg-header'),_c('el-container',{staticClass:"content"},[_c('dg-nav'),_c('dg-content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }